/** Normalize a shelf index type for display: 'pick bin' → 'Pick Bin', 'stock' → 'Stock'. */
export function formatType(type: string | null | undefined): string {
  if (!type || typeof type !== 'string') return type || '';
  const t = type.toLowerCase().trim();
  if (t === 'pick bin') return 'Pick Bin';
  if (t === 'stock') return 'Stock';
  return type;
}

interface LocationRowLike {
  id: string;
  sku?: string;
  shelf_index: string;
  type: string;
}

/** Shallow-compare two arrays of location rows by id, sku, shelf_index, and type. */
export function areLocationRowsEqual(a: LocationRowLike[] = [], b: LocationRowLike[] = []): boolean {
  if (a.length !== b.length) return false;
  for (let i = 0; i < a.length; i += 1) {
    const left = a[i];
    const right = b[i];
    if (!left || !right) return false;
    if (
      left.id !== right.id ||
      left.sku !== right.sku ||
      left.shelf_index !== right.shelf_index ||
      left.type !== right.type
    ) {
      return false;
    }
  }
  return true;
}
